import { watch } from 'vue'
import { useQuasar } from 'quasar'
import { useRegisterSW } from 'virtual:pwa-register/vue'

/**
 * Registers the service worker and, when a new version is waiting, shows a persistent
 * "Update available" banner. Reload activates the waiting worker and reloads the page.
 */
export function usePwaUpdate() {
  const $q = useQuasar()
  const { needRefresh, updateServiceWorker } = useRegisterSW()
  let banner: ReturnType<typeof $q.notify> | undefined

  watch(needRefresh, (waiting) => {
    if (!waiting) {
      banner?.()
      banner = undefined
      return
    }
    if (banner) return
    banner = $q.notify({
      message: 'Update available',
      type: 'info',
      timeout: 0,
      position: 'bottom',
      actions: [{ label: 'Reload', color: 'white', handler: () => updateServiceWorker(true) }]
    })
  })
}
